'use strict';
import {AvatarColors} from './AvatarColors';
import {InPlaceEditorFactory} from './InPlaceEditorService';
import {injector as ReduxUtilsInjector} from './ReduxUtils';

/**
 * Module dependencies
 */
const angular = require('angular');

module.exports = angular
  .module('app.core-utilities.domain', [])
  .constant('AvatarColors', AvatarColors)
  .run(ReduxUtilsInjector)
  .provider('ArchivableMixin', require('./ArchivableMixin.js'))
  .provider('AvatarMixin', require('./AvatarMixin.js'))
  .provider('FeedableMixin', require('./FeedableMixin.js'))
  .provider('MetricMixin', require('./MetricMixin.js'))
  .provider('OrgIdMixin', require('./OrgIdMixin.js'))
  .provider('OrgMixin', require('./OrgMixin.js'))

  .service('DomainUtils', require('./DomainUtils.js'))
  .factory('InPlaceEditorFactory', InPlaceEditorFactory)

  .directive('contenteditable', require('./ContenteditableDirective.js'))
  .directive('domainError', require('./DomainErrorDirective.js'));

/**
 * @typedef {Object} DomainLink<T>
 * @property {String} id
 * @property {String} collection
 * @property {String} [value]
 **/



// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/index.js